import React from "react";
import { Chip, Tooltip } from "@mui/material";
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";
import { PASTEL } from "./livechatTheme";

const MAX_INLINE_NAMES = 3;

/**
 * DEV-1423 — staff purchasing yang sedang membuka dashboard live chat (padanan "siapa yang ready" di
 * Lotus WA, tanpa tombol status manual). Data dari GET /livechat/agent/partner-staff/online + event
 * socket partner:staff:presence (index.jsx). Desktop: nama (maks 3, sisanya "+N"); HP: jumlah saja.
 */
export default function PartnerOnlineChip({ staff = [], compact = false }) {
    const names = staff.map((s) => s.userName);
    const inline = names.slice(0, MAX_INLINE_NAMES).join(", ") + (names.length > MAX_INLINE_NAMES ? ` +${names.length - MAX_INLINE_NAMES}` : "");
    const label = compact ? `${names.length}` : `Purchasing online (${names.length})${names.length ? `: ${inline}` : ""}`;
    return (
        <Tooltip title={names.length ? `Purchasing online: ${names.join(", ")}` : "Belum ada staff purchasing yang online"}>
            <Chip
                size="small"
                icon={<GroupsOutlinedIcon sx={{ fontSize: 16 }} />}
                label={label}
                aria-label={`Purchasing online: ${names.length}`}
                data-testid="partner-online-chip"
                sx={{
                    flexShrink: 1,
                    minWidth: 0,
                    maxWidth: compact ? undefined : 320,
                    fontWeight: 600,
                    color: PASTEL.primary,
                    backgroundColor: PASTEL.primarySoft,
                    "& .MuiChip-icon": { color: PASTEL.primary },
                }}
            />
        </Tooltip>
    );
}
